import { Link } from "react-router-dom";
import { HeartPulse, GraduationCap, Gift, Briefcase, BarChart3, Users, LifeBuoy, Rocket, Home, Eye } from "lucide-react";

const MODULE_META = {
  wellbeing: { label: "Wellbeing", icon: HeartPulse, blurb: "Confidential support, resources and check-ins are being prepared for you." },
  learning: { label: "Learning", icon: GraduationCap, blurb: "Courses, training records and development tools are on their way." },
  benefits: { label: "Benefits", icon: Gift, blurb: "Your Total Reward statement and benefits package are being finalised." },
  recruitment: { label: "Recruitment", icon: Briefcase, blurb: "Vacancies and the candidate pipeline are being set up." },
  reports: { label: "Reports", icon: BarChart3, blurb: "Workforce and HR reporting is being prepared." },
  directory: { label: "People Directory", icon: Users, blurb: "The staff directory is being set up." },
  help: { label: "Help centre", icon: LifeBuoy, blurb: "Guides and answers are being written for you." },
};

export function ComingSoon({ module }) {
  const meta = MODULE_META[module] || { label: "This area", icon: Rocket, blurb: "This section is being prepared." };
  const Icon = meta.icon;
  return (
    <div className="min-h-[60vh] grid place-items-center" data-testid="module-coming-soon">
      <div className="max-w-md text-center bg-white border border-slate-200 rounded-2xl shadow-sm p-10">
        <div className="mx-auto h-16 w-16 rounded-2xl bg-[#EFF8FF] grid place-items-center text-[#2EA3FD] mb-5">
          <Icon size={30} />
        </div>
        <p className="text-[11px] font-semibold uppercase tracking-widest text-[#2EA3FD] mb-1">Coming soon</p>
        <h1 className="text-2xl font-bold text-[#0B1A2F] font-display">{meta.label}</h1>
        <p className="text-sm text-slate-500 mt-3">{meta.blurb} We'll switch it on shortly — thanks for your patience.</p>
        <Link to="/" data-testid="coming-soon-home-btn"
          className="inline-flex items-center gap-2 mt-6 rounded-full bg-[#0B1A2F] hover:bg-[#162B48] text-white text-sm font-medium px-5 py-2.5 transition-colors">
          <Home size={16} /> Back to Home
        </Link>
      </div>
    </div>
  );
}

export function ModulePreviewBanner({ module }) {
  const meta = MODULE_META[module] || { label: "This module" };
  return (
    <div className="flex items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 text-amber-800 px-4 py-2.5 text-sm mb-2" data-testid="module-preview-banner">
      <Eye size={16} className="shrink-0" />
      <span><strong>Admin preview.</strong> {meta.label} is turned off, so staff currently see a “Coming soon” page here. Enable it in Settings › Roles &amp; permissions.</span>
    </div>
  );
}
